import { render, staticRenderFns } from "./AdminPermissions.vue?vue&type=template&id=4b75bd04"
import script from "./AdminPermissions.vue?vue&type=script&lang=js"
export * from "./AdminPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports